import { getHours, getMinutes, set, setMilliseconds, setMinutes, setSeconds } from 'date-fns';

export function floorToQuarterHour(date: Date) {
  const minutes = date.getMinutes();
  const flooredMinutes = Math.floor(minutes / 15) * 15;

  return setMilliseconds(setSeconds(setMinutes(date, flooredMinutes), 0), 0);
}

export const getNextQuarter = (dateTime: Date) => {
  const quarters = [
    {
      curr: 15,
      futureMinutes: 15,
      addHours: 0,
    },
    {
      curr: 30,
      futureMinutes: 30,
      addHours: 0,
    },
    {
      curr: 45,
      futureMinutes: 0,
      addHours: 1,
    },
    {
      curr: 60,
      futureMinutes: 0,
      addHours: 1,
    },
  ];
  const minutes = getMinutes(dateTime);
  const filteredQuarters = quarters.filter((x) => x.curr >= minutes);
  const nextSettings = filteredQuarters[0];
  return set(dateTime, {
    minutes: nextSettings.futureMinutes,
    hours: getHours(dateTime) + nextSettings.addHours,
  });
};
